"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var next_components_1 = require("@dotdev/next-components");
var Layouts = require("layouts");
var Snippets = require("snippets");
var AccountResetTemplate = /** @class */ (function (_super) {
    __extends(AccountResetTemplate, _super);
    function AccountResetTemplate(props) {
        var _this = _super.call(this, props) || this;
        _this.form = _this.props.data.form.reset_customer_password;
        return _this;
    }
    AccountResetTemplate.prototype.render = function () {
        return (React.createElement(Layouts.Theme, __assign({}, this.props),
            React.createElement(Snippets.Container, { className: "flex items-start justify-between mt-2-1", tag: "section" },
                React.createElement("div", { className: "hidden lg:block w-1/4" },
                    React.createElement(Snippets.Breadcrumbs, __assign({}, this.props))),
                React.createElement("div", { className: "w-full lg:w-1/2 text-center" }, this.props.data.shop.customer_accounts_enabled ? (React.createElement(React.Fragment, null,
                    React.createElement(Snippets.Heading, { size: "h4", tag: "h1", className: "font-bold leading-normal" }, "Reset password"),
                    React.createElement("p", { className: "mt-1 text-xs text-charcoal leading-normal" },
                        "Set a new password below for ",
                        this.form.data ? "the account" : "your account",
                        React.createElement("strong", null, this.form.data ? " " + this.form.data : ""),
                        "."))) : null),
                React.createElement("div", { className: "hidden lg:block w-1/4" })),
            React.createElement(Snippets.Container, { className: "my-3-2 md:my-6-4", tag: "section", width: "xxs" },
                React.createElement("div", { className: "md:px-7-2" }, this.props.data.shop.customer_accounts_enabled ? (React.createElement("div", { className: "flex flex-col items-center align-center" },
                    React.createElement("div", { className: "w-full" },
                        React.createElement(next_components_1.ShopifyNext.Components.Forms, { data: this.form, className: "w-full" },
                            React.createElement(Snippets.Input, { type: "password", name: "customer[password]", placeholder: "Password", className: "w-full mb-1-7", required: true, autoFocus: true }),
                            React.createElement(Snippets.Input, { type: "password", name: "customer[password_confirmation]", placeholder: "Confirm password", className: "w-full mb-1-7", required: true }),
                            React.createElement(Snippets.FormErrors, { form: this.form, className: "mb-1-7" }),
                            React.createElement(Snippets.Button, { type: "submit", style: "tertiary", className: "w-full" }, "Reset Password"))),
                    this.form.posted_successfully ? (React.createElement(Snippets.FormErrors, { errors: "Your password has been successfully saved.", className: "self-start mt-2-4" })) : null)) : (React.createElement(React.Fragment, null,
                    React.createElement(Snippets.FormErrors, { errors: "Customer accounts are disabled.", className: "justify-center mb-1-7" }),
                    React.createElement(Snippets.Button, { href: "/", className: "w-full" }, "Continue shopping")))))));
    };
    return AccountResetTemplate;
}(React.Component));
exports.AccountResetTemplate = AccountResetTemplate;
